import { HOLD_RETURNS_FIELD } from "./returnSettings.constants";

export const prepareReturnSetting = (formValues = {}) => ({
  returnSettings: {
    [HOLD_RETURNS_FIELD]: !!formValues[HOLD_RETURNS_FIELD],
  },
});

export const getReturnSettingsInitialValues = () => ({
  [HOLD_RETURNS_FIELD]: false,
});
